import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import { useFavoriteProduct } from 'src/hooks/use-favorite-product';

import { fShortenNumber } from 'src/utils/format-number';

import { Iconify } from '../iconify';
import { varTap, varHover, transitionTap } from '../animate';

// ----------------------------------------------------------------------

export function ButtonAddFavorite({ preview, isLiked, product, sx, ...other }) {
  const { isFavorite, totalFavorites, toggleFavorite } = useFavoriteProduct({
    preview,
    id: product.id,
    defaultValues: { isLiked, totalLikes: product.totalLikes },
  });

  return (
    <Box
      sx={[
        {
          textAlign: 'center',
          color: 'common.white',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <IconButton
        size="small"
        color="inherit"
        whileTap={varTap()}
        component={m.button}
        onClick={toggleFavorite}
        whileHover={varHover(1.08)}
        transition={transitionTap()}
        {...other}
      >
        <Iconify
          icon="solar:heart-bold"
          sx={{
            width: { xs: 32, md: 26 },
            height: { xs: 32, md: 26 },
            color: isFavorite ? 'error.main' : 'inherit',
          }}
        />
      </IconButton>

      <Box sx={{ typography: 'caption', opacity: 0.8 }}>{fShortenNumber(totalFavorites)}</Box>
    </Box>
  );
}
